import React from 'react';

import config from 'config';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { BUILDER_MODELS } from '~/builder/constants/models';
import { isBuilderPreview } from '~/builder/utils/isBuilderPreview';
import useBuilderJson from '~/builder/utils/useBuilderJson';
import {
  getProductGender,
  getCurrentProduct,
  constructGenderUrl,
} from '~/layout/utils/productHelpers';
import { Link } from '~/techstyle-shared/next-routes';
import { useProductDetailContext } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const LinkContainer = styled.span`
  margin-left: 8px;
  font-size: 14px;
`;

const StyledLink = styled.a`
  text-decoration: underline;
`;

export default function ShopByColorLink({
  masterProductId,
  filterByProductGender = false,
}) {
  const { query } = useRouter();
  const productDetailFromCtx = useProductDetailContext();
  const productDetail = productDetailFromCtx;
  const currentProduct = getCurrentProduct(productDetail, masterProductId);

  const LinkModelProperties = {
    modelName: BUILDER_MODELS.PAGE,
    query: {
      data: {
        shopByColorFplGlobalCode: {
          $in:
            currentProduct?.activeFeaturedProductLocationCodeList?.map(
              (code) => code.featuredProductLocationCode
            ) || [],
        },
      },
    },
    additionalQueryParams: {
      limit: 1,
      fields: 'data.url',
      sort: {
        lastUpdated: -1,
      },
    },
    builderQueries: {
      isPreview: isBuilderPreview({ query }),
    },
    options: {
      skipUserAttributes: true,
    },
  };

  const { builderJson, isLoading } = useBuilderJson(LinkModelProperties);

  if (
    isLoading ||
    !builderJson ||
    !currentProduct?.activeFeaturedProductLocationCodeList?.length
  ) {
    return null;
  }

  const maleTagId = config.get('public.productTags.maleTagId');
  const femaleTagId = config.get('public.productTags.femaleTagId');
  const tagIdList = Array.isArray(currentProduct.tagIdList)
    ? currentProduct.tagIdList
    : [];
  const hasMaleTag = tagIdList.includes(maleTagId);
  const hasFemaleTag = tagIdList.includes(femaleTagId);

  const tagGender = getProductGender(hasMaleTag, hasFemaleTag);

  const url = builderJson?.data?.url;

  const urlWithGender = constructGenderUrl(
    url,
    filterByProductGender,
    tagGender
  );

  return (
    <LinkContainer>
      <Link href={urlWithGender}>
        <StyledLink>
          <FormattedMessage
            id="site_pdp.shop_this_color"
            defaultMessage="(Shop This Color)"
          />
        </StyledLink>
      </Link>
    </LinkContainer>
  );
}

ShopByColorLink.propTypes = {
  filterByProductGender: PropTypes.bool,
  masterProductId: PropTypes.number.isRequired,
};
